import React from "react";
import { SolutionFeedbackFieldProps } from "../../../../../../../../types/feedback/feedback";
import CustomSelect from "../../../../../../../common/custom-select";

const VALUE_OPTIONS = [
  { value: "1", label: "No value" },
  { value: "2", label: "Low value" },
  { value: "3", label: "Moderate value" },
  { value: "4", label: "High value" },
  { value: "5", label: "Critical" },
];

const RatingField: React.FC<SolutionFeedbackFieldProps> = ({ formState, setFormState }) => {
  return (
    <div>
      <label className="block text-[16px] font-medium text-brand-textSubheading mb-[24px]">
        How valuable would this be for your team?
      </label>
      <CustomSelect
        options={VALUE_OPTIONS}
        selectedValue={formState.rating !== null ? String(formState.rating) : ""}
        onChange={(value) => setFormState((prev) => ({ ...prev, rating: parseInt(value, 10) }))}
        placeholder="Select a value level..."
      />
    </div>
  );
};

export default RatingField;
